import { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import {
  Actions,
  selectMobileFilterDrawerForGymsIsOpen,
  selectMobileFilterDrawerForSocialEventsIsOpen,
} from '@pass-frontend/common/offerings/data-access';
import { OFFERING_TYPES } from '@pass-frontend/data-access/types';

export interface UseMobileFilterDrawer {
  isMobileFilterOpened: boolean;
  setMobileFilterVisibility: (visbile: boolean) => void;
  toggleMobileFilter: () => void;
}

export function useMobileFilterDrawer(
  offeringType: OFFERING_TYPES,
): UseMobileFilterDrawer {
  const dispatch = useDispatch();

  const setMobileFilterVisibility = useCallback(
    (visibile: boolean) => {
      switch (offeringType) {
        case OFFERING_TYPES.FACILITY:
          dispatch(
            Actions.updateVisibilityOfMobileFilterDrawerForGyms(visibile),
          );
          break;
        case OFFERING_TYPES.EVENT:
          dispatch(
            Actions.updateVisibilityOfMobileFilterDrawerForSocialEvents(
              visibile,
            ),
          );
          break;
      }
    },
    [offeringType, dispatch],
  );

  const toggleMobileFilter = useCallback(() => {
    switch (offeringType) {
      case OFFERING_TYPES.FACILITY:
        dispatch(Actions.toggleVisibilityOfMobileFilterDrawerForGyms());
        break;
      case OFFERING_TYPES.EVENT:
        dispatch(Actions.toggleVisibiltyOfMobileFilterDrawerForSocialEvents());
        break;
    }
  }, [offeringType, dispatch]);

  const mobileFilterDrawerForGymsIsOpen = useSelector(
    selectMobileFilterDrawerForGymsIsOpen,
    shallowEqual,
  );
  const mobileFilterDrawerForSocialEventsIsOpen = useSelector(
    selectMobileFilterDrawerForSocialEventsIsOpen,
    shallowEqual,
  );

  const isMobileFilterOpened = useMemo(() => {
    switch (offeringType) {
      case OFFERING_TYPES.FACILITY:
        return mobileFilterDrawerForGymsIsOpen;
      case OFFERING_TYPES.EVENT:
        return mobileFilterDrawerForSocialEventsIsOpen;
    }
  }, [
    offeringType,
    mobileFilterDrawerForGymsIsOpen,
    mobileFilterDrawerForSocialEventsIsOpen,
  ]);

  return {
    isMobileFilterOpened,
    setMobileFilterVisibility,
    toggleMobileFilter,
  };
}

export default useMobileFilterDrawer;
